// -----------------------------------------------------------------------------
// WARNING: this file is automatically generated by the import-plugins script.
//          Any change to this file will be overwritten when importing plugins.
// -----------------------------------------------------------------------------

const plugins = [];
export default plugins;
